class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.announcementKey = Theme.keys.announcement_key;
    this.resizeDebounceTimer = null;

    if (this.isAnnouncementClosed()) {
      return;
    }

    this.setAttribute("data-announcement-bar", "true");
    document.documentElement.setAttribute("data-announcement-bar", "true");

    this.closeButton = this.querySelector("button[data-dialog-close]");

    this.init();
  }

  init() {
    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.handleClose.bind(this));
    }
  }

  disconnectedCallback() {
    if (this.closeButton) {
      this.closeButton.removeEventListener(
        "click",
        this.handleClose.bind(this),
      );
    }
  }

  handleClose() {
    localStorage.setItem(this.announcementKey, Date.now().toString());

    this.setAttribute("data-announcement-bar", "false");
    document.documentElement.removeAttribute("data-announcement-bar");

    document.dispatchEvent(
      new CustomEvent("announcement-bar:closed", { bubbles: true }),
    );
  }

  isAnnouncementClosed() {
    return localStorage.getItem(this.announcementKey) !== null;
  }
}

customElements.define("announcement-bar", AnnouncementBar);
